<div appFocusOnInit class="error-validation">
  <div class="error-validation-icon">
    <img src="{{ 'assets/images/icon-error-message.svg' | cheminAbsoluStatique }}" alt="" class="error-icon" />
  </div>
  <div class="error-validation-content">
    <div *ngIf="customMessage; else errorList">
      <span class="error-validation-text">{{ customMessage }}</span>
      <a *ngIf="linkText" class="link" [routerLink]="linkRef">{{ linkText }}</a>
    </div>

    <ng-template #errorList>
      <div class="error-validation-text" [innerText]="'erreur.message-validation' | translate"></div>
      <ul class="error-validation-list">
        <li class="error-validation-list-item" *ngFor="let error of errors">
          <a class="error-validation-list-fragment" [href]="'#' + error.inputId" [link]="'#' + error.inputId">
            <span class="sr-only" [innerText]="'erreur.general' | translate"></span>
            <span class="error-validation-list-fragment-text" [innerText]="error.inputLabel"></span>
          </a>
        </li>
      </ul>
    </ng-template>
  </div>
</div>
<mat-divider *ngIf="hasDivider" class="divider"></mat-divider>
